<template>
  <Pie id="my-chart-pie" :options="chartOptions" :data="chartData" />
</template>

<script>
import { Pie } from "vue-chartjs";
import { pieLabels } from "./pieLabels";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  pieLabels
);

export default {
  name: "BarChart1",
  components: {
    Pie,
  },
  props: {
    chartId: {
      type: String,
      default: "pie-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      chartData: {
        labels: [
          "Digital Services\n33.6%",
          "Live Concerts\n& Events  19.5%",
          "General Licensing\n18.1%",
          "Free-to-Air\nTelevision  13.3%",
          "Pay Television\n7.0%",
          "Radio  7.1%",
          "Cinema 1.3%",
        ],
        datasets: [
          {
            backgroundColor: [
              "rgba(139,197,63, 1)",
              "rgba(139,197,63, 0.85)",
              "rgba(139,197,63, 0.65)",
              "rgba(139,197,63, 0.45)",
              "rgba(139,197,63, 0.25)",
              "rgba(139,197,63, 0.15)",
              "rgba(139,197,63, 0.1)",
            ],
            hoverBackgroundColor: [
              "rgba(122,171,57, 0.9)",
              "rgba(122,171,57, 0.8)",
              "rgba(122,171,57, 0.7)",
              "rgba(122,171,57, 0.6)",
              "rgba(122,171,57, 0.5)",
              "rgba(122,171,57, 1)",
              "rgba(122,171,57, 1)",
            ],
            data: [33.6, 19.5, 18.1, 13.3, 7.0,  7.1, 1.3],
            borderWidth: 0,
          },
        ],
      },
      chartOptions: {
        plugins: {
          tooltip: {
            enabled: false,
          },
          scale: {
            delay: 1000,
          },
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
        animation: {
          animateScale: true,
        },
        layout: {
          padding: {
            top: 60,
            bottom: 60,
          },
        },
        responsive: true,
        aspectRatio: 1.8,
        // maintainAspectRatio: false,
        cutout: "70%",
        hoverOffset: 5,
      },
      plugins: [pieLabels],
    };
  },
};
</script>
